import { LogoImgDefault } from './LogoImgDefault.js';

export const LogoImgOrigin = (label, type, slug) => {
    if (label === 'icon') {
        try {
            const datas = require(`../assets/images/origins/${type}/${slug}/${slug}-00.webp`);
            return datas.length > 0 ? datas : LogoImgDefault('icon');
        } catch(e) {
            console.log(e);
        }
    }
    if (label === 'img') {
        try {
            const images = require.context(`../assets/images/origins`, true, /\.(webp)$/i);
            const gallery = (type, slug) => {
                return images.keys()
                    .filter(path => path.startsWith(`./${type}/${slug}`))
                    .map(path => (images(path)));
            }
            return gallery(type, slug).length > 0 ? gallery(type, slug) : LogoImgDefault('img');
        } catch(e) {
            console.log(e);
        }
    }
}
